export default __webpack_public_path__ + "static/media/vehicle.73b6ed9c550da27e453b1d72420f943e.svg";